import type { FC } from "react"

import type { InventoryLotWithPallet } from "../../../../types"
import { createAdjustmentQuantityToMoveSchema } from "../../schemas"
import { AdjustmentSelectedLots } from "../AdjustmentSelectedLots"

import { formatNumber, roundToPrecision } from "@/utils/number"

interface SplitPalletsAdjustmentFormLotsProps {
  selectedLots: InventoryLotWithPallet[]
  uomName: string
  quantityByLotId: Record<string, number | null>
  onQuantityChange: (lotId: string, value: number | null) => void
  onLotRemove: (lotId: string) => void
}

export const SplitPalletsAdjustmentFormLots: FC<SplitPalletsAdjustmentFormLotsProps> = ({
  selectedLots,
  uomName,
  quantityByLotId,
  onQuantityChange,
  onLotRemove,
}) => {
  return (
    <AdjustmentSelectedLots
      selectedLots={selectedLots}
      uomName={uomName}
      testIdPrefix='inventory.split-pallets-adjustment-form-lots'
      title='Specify Changes'
      emptyState={{
        title: "No source lots selected",
        description: "Select one or more source lot(s) from the table above to specify the quantity to split.",
      }}
      inputColumn={{
        header: "Qty to Move",
        values: quantityByLotId,
        createSchema: createAdjustmentQuantityToMoveSchema,
        onChange: onQuantityChange,
      }}
      derivedColumn={{
        header: "Remaining Qty",
        render: (inputQuantity, lotQuantity, uomName) =>
          `${formatNumber(roundToPrecision(lotQuantity - inputQuantity, 2))} ${uomName}`,
      }}
      onLotRemove={onLotRemove}
    />
  )
}
